import React, { createContext, useState, useContext, useEffect } from 'react';

const LightboxContext = createContext();

export const useLightbox = () => useContext(LightboxContext);

const LightboxProvider = ({ children }) => {
  const [activeLightbox, setActiveLightbox] = useState(null);

  // A page-scoped "default" demo lightbox. Components that own a demo form
  // (e.g. the pricing page) register it here so that CTAs which merely link to
  // /demo can open the popup instead of navigating. Registered on mount and
  // cleared on unmount, so it never leaks to other pages.
  const [demoLightbox, setDemoLightbox] = useState(null);

  const openLightbox = lightbox => setActiveLightbox(lightbox);

  const closeLightbox = () => setActiveLightbox(null);

  const registerDemoLightbox = lightbox => setDemoLightbox(lightbox);

  useEffect(() => {
    if (activeLightbox) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [activeLightbox]);

  return (
    <LightboxContext.Provider
      value={{
        activeLightbox,
        openLightbox,
        closeLightbox,
        demoLightbox,
        registerDemoLightbox,
      }}
    >
      {children}
    </LightboxContext.Provider>
  );
};

export default LightboxProvider;
